import React, { useEffect, useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import { Button, DateField, EmailField, FunctionField, SimpleShowLayout, TopToolbar, useGetOne, usePermissions, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { useParams } from "react-router-dom";
import PasswordIcon from "@mui/icons-material/VpnKey";

const UserShow = () => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams(); 

  const redirect = useRedirect();

  const { data, isLoading } = useGetOne("users", { id });
  useEffect(() => {
    if(!isLoading && data){
      setUser(data);
    }
  },[data,isLoading]);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
        <TopToolbar>
            <Button
                label="パスワードリセット"
                onClick={() => redirect(`/reset-password/${id}`)}
                startIcon={<PasswordIcon />}
            />
            <Button
                label="ユーザー編集"
                onClick={() => redirect(`/users/${id}`)}
                startIcon={<EditIcon />}
            />
        </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  const {permissions} = usePermissions();
  if(permissions < 1){
    return;
  }

  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent>
            <SimpleShowLayout record={user}>
                <FunctionField source="userName" label={labelStyle("ユーザー名")} style={{ paddingLeft: "5px" }} render={record => {return record.userName}} />
                <FunctionField source="name" label={labelStyle("名前")} style={{ paddingLeft: "5px" }} render={record => {return record.name}}/>
                <EmailField source="mail" label={labelStyle("メール")} style={{ paddingLeft: "5px" }} type="email" />
                <FunctionField
                    label={labelStyle("権限")} 
                    style={{ paddingLeft: "5px" }}
                    render={record => {
                    switch (record.userType) {
                        case 0:
                        return "一般スタッフ";
                        case 1:
                        return "管理スタッフ";
                        // case 2:
                        // return "マスター";
                        default:
                        return "不明な権限";
                    }
                    }}
                />
                <DateField source="createDate" label={labelStyle("登録日")} style={{ paddingLeft: "5px" }} />
            </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default UserShow;

